import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import ComparisonSection from './components/ComparisonSection';
import ContentGrid from './components/ContentGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import SafetySection from './components/SafetySection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <FeatureGrid />
        <ComparisonSection />
        <ContentGrid />
        <TestimonialSection />
        <CTASection />
        <SafetySection />
      </main>
      <Footer />
    </>
  );
}